// extracted by mini-css-extract-plugin
export default {"arrowColor":"#44cc94","arrowColorDisabled":"#dce3eb","colorOrange":"#ff6332","calendarContainer":"calendarContainer__2VdTu","calendar":"calendar__153j9","month-heading":"month-heading__24CSC","month":"month__3Krdo","switch-month":"switch-month__2nOxZ","week-days":"week-days__IJCsX","calendarLegend":"calendarLegend__1Yznc","color":"color__3lq7T","calendarLegendCaption":"calendarLegendCaption__3UBaj","booked":"booked__3dxal","available":"available__2A_hM"};
    if(module.hot) {
      // 1790586310130
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  